// @mui
import { Box, Tooltip, ListItemButtonProps, useTheme, Divider } from '@mui/material';
import Link from '@mui/material/Link';

//
import Iconify from '../../Iconify';
//
import { NavItemProps } from '../type';
import { ListItemStyle, ListItemTextStyle, ListItemIconStyle } from './style';
import useAuth from 'src/hooks/useAuth';

// ----------------------------------------------------------------------

type Props = NavItemProps & ListItemButtonProps;

export default function NavItem({ item, depth, active, open, isCollapse, handleClickItem, ...other }: Props) {
  const { user } = useAuth();
  const theme = useTheme();

  const { title, icon, info, children, disabled, caption } = item;

  const color = user && active ? user.customer.color ? user.customer.color : theme.palette.primary.main : "#96a1ac";

  const renderContent = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Link onClick={handleClickItem} target="_blank" rel="noopener" underline="none">
        <ListItemStyle depth={depth} active={active} disabled={disabled}>
          {icon &&
            <ListItemIconStyle sx={{ color: color }}>
              {icon(color)}
            </ListItemIconStyle>}
          <ListItemTextStyle
            isCollapse={isCollapse}
            primary={title}
            secondary={
              caption && (
                <Tooltip title={caption} placement="top-start">
                  <span>{caption}</span>
                </Tooltip>
              )
            }
            primaryTypographyProps={{
              noWrap: true,
              variant: active ? 'body1_14' : 'body2',
              color: user && active ? user.customer.color ? user.customer.color : theme.palette.primary.main : '',
            }}
            secondaryTypographyProps={{
              noWrap: true,
              variant: "body2",
            }}
          />

          {!isCollapse && (
            <>
              {info && (
                <Box component="span" sx={{ lineHeight: 0 }}>
                  {info}
                </Box>
              )}

              {!!children && (
                <Iconify
                  icon={open ? 'eva:arrow-ios-downward-fill' : 'eva:arrow-ios-forward-fill'}
                  sx={{ width: 16, height: 16, ml: 1, flexShrink: 0 }}
                />
              )}
            </>
          )}
        </ListItemStyle>
      </Link>
      <Divider />
    </Box>
  );

  return renderContent;
}

// // ----------------------------------------------------------------------

// type DotIconProps = {
//   active: boolean;
// };

// export function DotIcon({ active }: DotIconProps) {
//   return (
//     <ListItemIconStyle>
//       <Box
//         component="span"
//         sx={{
//           width: 4,
//           height: 4,
//           borderRadius: '50%',
//           bgcolor: 'text.disabled',
//           transition: (theme) =>
//             theme.transitions.create('transform', {
//               duration: theme.transitions.duration.shorter,
//             }),
//           ...(active && {
//             transform: 'scale(2)',
//             bgcolor: 'primary.main',
//           }),
//         }}
//       />
//     </ListItemIconStyle>
//   );
// }
